import Entity, { IEntity } from '../abstract/Entity';
import { IWall } from '../abstract/Wall';
import { ICompass } from './CompassModel';
import { IElement } from './ElementModel';
import { IModel2D } from './Model2DModel';
import { IProduct } from './ProductModel';
import { IRoom } from './RoomModel';

export interface IBuildingLevel extends IEntity {
  level: number;
  rooms: Array<IRoom>;
  compass: ICompass;

  walls: IWall[];
  products: IProduct[];
  elements: IElement[];
  models2D: IModel2D[];
}

class BuildingLevelModel extends Entity implements IBuildingLevel {
  level: number;
  rooms: Array<IRoom>;
  compass: ICompass;

  walls: IWall[];
  products: IProduct[];
  elements: IElement[];
  models2D: IModel2D[];

  constructor(
    level: number,
    rooms: Array<IRoom>,
    compass: ICompass,
    walls: IWall[] = [],
    products: IProduct[] = [],
    elements: IElement[] = [],
    models2D: IModel2D[] = [],
  ) {
    super();
    this.level = level;
    this.rooms = rooms;
    this.compass = compass;

    this.walls = walls;
    this.products = products;
    this.elements = elements;
    this.models2D = models2D;
  }

  getLevel(): number {
    return this.level;
  }

  setLevel(level: number): void {
    this.level = level;
  }

  getRooms(): Array<IRoom> {
    return this.rooms;
  }

  getRoomById(uuid: string): IRoom | undefined {
    return this.rooms.find((room) => room.uuid === uuid);
  }

  setRooms(rooms: Array<IRoom>): void {
    this.rooms = rooms;
  }

  setRoomById(room: IRoom, uuid: string) {
    const relatedIndex = this.rooms.findIndex((room) => room.uuid === uuid);
    if (relatedIndex === -1) return false;

    this.rooms[relatedIndex] = room;
    return true;
  }

  getCompass(): ICompass {
    return this.compass;
  }

  setCompass(compass: ICompass): void {
    this.compass = compass;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      level: this.level,
      rooms: this.rooms.map((r) => r.toJSON?.() ?? r),
      compass: this.compass.toJSON(),
      walls: this.walls?.map((w: any) => w.toJSON?.() ?? w),
      products: this.products?.map((p: any) => p.toJSON?.() ?? p),
      elements: this.elements?.map((e: any) => e.toJSON?.() ?? e),
      models2D: this.models2D?.map((m: any) => m.toJSON?.() ?? m),
    };
  }
}

export default BuildingLevelModel;
